<script>
export default {

  name: 'CarSectionSelection',

  props: {
    sections: {
      type: Array,
      required: true
    },

    // support for v-model
    value: {
      type: Number,
      required: true
    }
  }

}
</script>

<template>
  <div>

    <div class="row hide-for-small-only" v-if="teamsiteConfig.car_sections.length > 1">
      <mq-tabs class="tabs" :selectedIndex="value" :items="teamsiteConfig.car_sections" @select="$emit('input', $event)">
        <mq-tab slot="tab" slot-scope="props" :title="props.item.name"></mq-tab>
      </mq-tabs>
    </div>

    <div class="row show-for-small-only" v-if="teamsiteConfig.car_sections.length > 1">
      <div class="column mobile-select">
        <select class="select" @input="$emit('input', $event.target.value)" :value="value">
          <option v-for="(item, index) in teamsiteConfig.car_sections" :key="index" :value="index">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>

  </div>

</template>

<style lang="scss" scoped>
  .mobile-select {
    padding: 15px;
  }
</style>


// WEBPACK FOOTER //
// src/components/CarSectionSelection.vue